import { settings } from '@/constants/settings';

const { auth } = settings;

export const isAuthenticated = (): boolean => !!(auth && auth.username && auth.spa_id);

export const getSpaId = (): number | undefined => auth?.spa_id;

export const getUsername = (): string | undefined => auth?.username;
